import { Controller } from '@hotwired/stimulus';
import { scheduleInitializeTruncatedElements } from '../utils/truncate';

export default class extends Controller {
  connect() {
    this.refresh = this.refresh.bind(this);
    this.resizeObserver = new ResizeObserver(this.refresh);
    this.resizeObserver.observe(this.element);
    this.refresh();
  }

  disconnect() {
    this.resizeObserver?.disconnect();
  }

  refresh() {
    scheduleInitializeTruncatedElements(this.element);
  }
}
